import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { IMAGES } from '../mock/mock';

const Solutions = () => {
  const { t, lang } = useLang();
  const rtl = lang === 'ar';
  return (
    <section id="solutions" className="relative py-32 md:py-40 border-t border-cream/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="mb-20">
          <div className="font-mono text-[11px] tracking-[0.35em] text-[#c99a3d] mb-6">{t.solutions.kicker}</div>
          <h2 className="font-serif text-cream font-light text-[42px] md:text-[68px] leading-[1.05] tracking-tight max-w-[1100px]">
            {t.solutions.titleA} <span className="italic text-[#c99a3d]">{t.solutions.titleAccent}</span> {t.solutions.titleB}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.solutions.items.map((s, i) => (
            <div key={i} className="card-lift group relative border border-cream/10 rounded-sm overflow-hidden bg-[#0d1526]/60">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={IMAGES.solutions[i]} alt={s.title} className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1220] via-[#0a1220]/30 to-transparent"></div>
                <div className={`absolute top-5 ${rtl ? 'right-5' : 'left-5'} font-mono text-[10px] tracking-[0.3em] text-cream/85`}>
                  {s.n} · <span className="text-[#c99a3d]">{s.tag}</span>
                </div>
              </div>

              <div className="p-8 md:p-10">
                <div className="font-serif italic text-cream/75 text-lg mb-3">{s.kicker}</div>
                <h3 className="font-serif text-cream text-[32px] md:text-[38px] leading-[1.1] mb-5 font-light">{s.title}</h3>
                <p className="text-cream/65 text-[14px] leading-[1.8] max-w-[520px]">{s.body}</p>

                <a href="#contact" className="group/lb inline-flex items-center gap-2 mt-8 font-mono text-[11px] tracking-[0.28em] text-cream/80 hover:text-[#c99a3d] transition-colors">
                  {t.solutions.learn} <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover/lb:-translate-y-0.5 group-hover/lb:translate-x-0.5" strokeWidth={1.6} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
